import React, { ChangeEvent} from 'react';

export interface IFile {
    type: string,
    showFilePicker: boolean,
    shareContent:boolean,
    onFileChange:Function
}

const FileUIType= ({ showFilePicker, shareContent,onFileChange}: any) => {
    const onChange = (e: ChangeEvent<HTMLInputElement>) => {
        if (e.target.value==="showFilePicker"){
            showFilePicker=e.target.checked
        }else{
            shareContent= e.target.checked
        }
        onFileChange({ type: 'file', showFilePicker:showFilePicker, shareContent:shareContent});
    }
    return (
        <div className="slds-checkbox">
            <input role="showFilePicker" type="checkbox" name="showFilePicker" id="showFilePicker"
                value="showFilePicker"
                onChange={onChange}
                checked={showFilePicker}
            />
            <label className="slds-checkbox__label" htmlFor="showFilePicker">
                <span className="slds-checkbox_faux"></span>
                <span className="slds-form-element__label">Show File Picker</span>
            </label>
            <input role="shareContent" type="checkbox" name="shareContent" id="shareContent"
                value="shareContent"
                onChange={onChange}
                checked={shareContent}
            />
            <label className="slds-checkbox__label" htmlFor="shareContent">
                <span className="slds-checkbox_faux"></span>
                <span className="slds-form-element__label">Share Content</span>
            </label>
        </div>
    );
}

export default FileUIType;